var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import pick from 'lodash/pick';
import { reduxKey } from './constants';
import { logPageView } from './actions';
var actionHandlers = handleActions((_a = {},
    _a[logPageView.toString()] = function (state, _a) {
        var payload = _a.payload;
        return __assign(__assign({}, state), { pageview: pick(payload, 'view', 'component', 'typeid', 'itemid') });
    },
    _a), { pageview: {} });
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map